import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller, useWatch } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import {
  AllChemist,
  AllParameter,
  allSampleManagement,
  AllTestMethod,
  allVerificationType,
} from "../../../../../../../../features/admin/common/Slice";
import Select from "react-select";

import Common_Back_Btn from "../../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";

import {
  GetSingle,
  Update,
  GetAll,
} from "../../../../../../../../features/admin/quality_management/process_requirement/accuracy/Slice";

import { formatDateForInput } from "../../../../../../../../utils/common";
import { useFieldArray } from "react-hook-form";

function Accuracy_Edit_Offcanvas({ show, handleClose, id }) {
  const dispatch = useDispatch();
  const [removedFiles, setRemovedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(null);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const all_sample_management = useSelector(
    (state) => state.common.all_sample_management,
  );
  const all_test_method = useSelector((state) => state.common.all_test_method);

  const all_parameter = useSelector((state) => state.common.all_parameter);

  const all_verification_type = useSelector(
    (state) => state.common.all_verification_type,
  );

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "observations",
  });

  useEffect(() => {
    dispatch(allSampleManagement());
    dispatch(AllTestMethod());
    dispatch(AllParameter());
    dispatch(allVerificationType());
  }, [dispatch]);

  /* ---------------- GET SINGLE ---------------- */
  const GetData = async (id) => {
    try {
      setLoading(true);
      const res = await dispatch(GetSingle(id));

      if (res.meta?.requestStatus === "fulfilled") {
        const data = res.payload.data;

        //map ID → label
        const verifyType = all_verification_type?.find(
          (o) => o.value === data.type_of_verification_id,
        )?.label;

        // const parameters = all_parameter?.find(
        //   (o) =>
        //     o.value ===
        //     data.parameters.filter((p) => p.certified_value || p.result_value),
        // )?.label;

        const sampleManagement = all_sample_management?.find(
          (o) => o.value === data.sample_id,
        )?.label;

        const testMethod = all_test_method?.find(
          (o) => o.value === data.test_method_id,
        )?.label;

        const observationsData =
          data.Selection_Type_Record_Observations?.map((o) => ({
            value: o.observation_value,
          })) || [];

        const apiParams =
          data.Accuracy_Parameters || data.accuracy_parameters || [];

        const mappedParameters = all_parameter.map((param) => {
          const existing = apiParams.find(
            (p) => Number(p.parameter_id) === Number(param.value),
          );

          return {
            parameter_id: param.value,
            certified_value: existing?.certified_value || "",
            result_value: existing?.result_value || "",
          };
        });

        reset({
          test_method_id: data.test_method_id || null,
          type_of_verification_id: data.type_of_verification_id || null,
          sample_management_id: data.sample_id || null,
          average: data.average || "",
          chemist_assigned_id: data.user_id || null,
          std_deviation: data.std_deviation || "",
          rsd: data.rsd || "",
          remark: data.remark || "",
          date: data.date ? formatDateForInput(data.date) : "",
          parameters: mappedParameters,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      show &&
      id &&
      all_parameter?.length &&
      all_verification_type?.length &&
      all_sample_management?.length &&
      all_test_method?.length
    ) {
      GetData(id);
    }
  }, [
    show,
    id,
    all_parameter,
    all_verification_type,
    all_sample_management,
    all_test_method,
  ]);

  /* ---------------- SUBMIT ---------------- */
  const onSubmit = async (data) => {
    try {
      const sendData = {
        test_method_id: data.test_method_id,
        type_of_verification_id: data.type_of_verification_id,
        checked_by: data.chemist_assigned_id,
        sample_id: data.sample_management_id,
        average: data.average,
        std_deviation: data.std_deviation,
        rsd: data.rsd,
        remark: data.remark,
        date: data.date,
        parameters: data.parameters.filter(
          (p) => p.certified_value || p.result_value,
        ),
      };

      const res = await dispatch(Update({ id, sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccess(true);
        dispatch(GetAll());
        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
      } else {
        setShowError(res.payload?.response?.data?.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- AUTO HIDE SUCCESS ---------------- */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleRemoveCompanies = () => {
    setCompaniesPreview(null);
    setValue("degree", null);
    setRemovedFiles((prev) =>
      prev.includes("degree") ? prev : [...prev, "degree"],
    );
  };

  const handleRemoveAttach = () => {
    setAttachPreview(null);
    setValue("training_certificate", null);
    setRemovedFiles((prev) =>
      prev.includes("training_certificate")
        ? prev
        : [...prev, "training_certificate"],
    );
  };
  const all_chemist = useSelector((state) => state.common.all_chemist);

  useEffect(() => {
    dispatch(AllChemist());
  }, [dispatch]);

  return (
    <Offcanvas
      className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Accuracy
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Type Of Verification</Form.Label>
                  <Controller
                    name="type_of_verification_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Type of Verification is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_verification_type}
                        value={
                          all_verification_type?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.type_of_verification_id && (
                    <span className="text-danger">
                      {errors.type_of_verification_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Sample Id</Form.Label>
                  <Controller
                    name="sample_management_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Sample is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_sample_management}
                        value={
                          all_sample_management?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.sample_management_id && (
                    <span className="text-danger">
                      {errors.sample_management_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Test Method</Form.Label>
                  <Controller
                    name="test_method_id"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Sample is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_test_method}
                        value={
                          all_test_method?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.test_method_id && (
                    <span className="text-danger">
                      {errors.test_method_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Remark</Form.Label>
                  <Form.Control
                    {...register("remark", {
                      required: "remark is required",
                    })}
                  />
                  {errors.remark && (
                    <span className="text-danger">{errors.remark.message}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Checked By</Form.Label>
                  <Controller
                    name="chemist_assigned_id"
                    control={control}
                    rules={{ required: "Chemist is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_chemist}
                        value={
                          all_chemist?.find((o) => o.value === field.value) ||
                          null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.chemist_assigned_id && (
                    <Form.Text className="text-danger">
                      {errors.chemist_assigned_id.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    {...register("date", {
                      required: "Date is required",
                    })}
                  />
                  {errors.date && (
                    <span className="text-danger">{errors.date.message}</span>
                  )}
                </Form.Group>
              </div>

              {/* ===== Certified Value ===== */}
              <div className="row mt-3">
                <div className="col-md-12">
                  <Form.Label>Certified Value Parameter</Form.Label>
                </div>

                {all_parameter?.map((item, index) => (
                  <div className="col-md-3" key={item.value}>
                    <Form.Control
                      placeholder={item.label}
                      {...register(`parameters.${index}.certified_value`)}
                    />

                    <input
                      type="hidden"
                      value={item.value}
                      {...register(`parameters.${index}.parameter_id`)}
                    />
                  </div>
                ))}
              </div>

              {/* ===== Result Value ===== */}
              <div className="row mt-3">
                <div className="col-md-12">
                  <Form.Label>Result Value</Form.Label>
                </div>

                {all_parameter?.map((item, index) => (
                  <div className="col-md-3" key={`result-${item.value}`}>
                    <Form.Control
                      placeholder={item.label}
                      {...register(`parameters.${index}.result_value`)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="offcanvas_footer_holder">
            {success ? (
              <Success_Toster successText="Updated Successfully!" />
            ) : (
              <>
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                {/* <Refresh_btn /> */}
              </>
            )}
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Accuracy_Edit_Offcanvas;
